import React from 'react';
import { LogOut, ShieldAlert } from 'lucide-react';

/**
 * Shown while a platform admin is viewing another user's dashboard.
 * Restores the admin session from localStorage.admin_token_backup.
 */
export default function ImpersonationBanner({ user, setUser }) {
  if (!user?.impersonating && !localStorage.getItem('admin_token_backup')) {
    return null;
  }

  const adminEmail = user?.impersonator_email || localStorage.getItem('admin_impersonator_email') || 'admin';
  const targetEmail = user?.email || 'user';

  const exitImpersonation = async () => {
    const adminToken = localStorage.getItem('admin_token_backup');
    if (!adminToken) {
      localStorage.removeItem('token');
      localStorage.removeItem('admin_impersonator_email');
      if (typeof setUser === 'function') setUser(null);
      window.location.href = '/login';
      return;
    }
    localStorage.setItem('token', adminToken);
    localStorage.removeItem('admin_token_backup');
    localStorage.removeItem('admin_impersonator_email');
    try {
      const API_URL = (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL !== '')
        ? process.env.REACT_APP_BACKEND_URL
        : '';
      const res = await fetch(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      });
      if (res.ok && typeof setUser === 'function') {
        setUser(await res.json());
      }
    } catch {
      /* ignore — hard reload below restores session */
    }
    window.location.href = '/dashboard';
  };

  return (
    <div
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-between gap-2 border-b border-amber-500/40 bg-amber-500 px-4 py-2 text-sm font-semibold text-black"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <span className="truncate">
          Viewing as <strong>{targetEmail}</strong>
          <span className="font-normal opacity-80"> · logged in via {adminEmail}</span>
        </span>
      </div>
      <button
        type="button"
        onClick={exitImpersonation}
        className="inline-flex items-center gap-1.5 rounded-full border-2 border-black bg-black px-3 py-1 text-xs font-bold text-amber-300 hover:bg-zinc-900"
        data-testid="exit-impersonation-button"
      >
        <LogOut className="w-3.5 h-3.5" />
        Exit to admin
      </button>
    </div>
  );
}
